import SidebarNavList from "./SidebarNavList";
import { Typography } from "@mui/material";
import React from "react";
import styled from "styled-components/macro";

const Title = styled(Typography)`
  color: ${(props) => props.theme.palette.sidebar.sectionTitleColor};
  font-size: ${(props) => props.theme.typography.caption.fontSize};
  padding: ${(props) => props.theme.spacing(4)}
    ${(props) => props.theme.spacing(7)} ${(props) => props.theme.spacing(1)};
  text-transform: uppercase;
  display: block;
`;

const SidebarNavSection = ({ title, pages }) => (
  <nav>
    {title && <Title variant="subtitle2">{title}</Title>}
    <SidebarNavList pages={pages} depth={0} />
  </nav>
);

export default SidebarNavSection;
